import { render } from "./BlockExplorer.vue?vue&type=template&id=dc262cde"
import script from "./BlockExplorer.vue?vue&type=script&lang=js"
export * from "./BlockExplorer.vue?vue&type=script&lang=js"

import "./BlockExplorer.vue?vue&type=style&index=0&id=dc262cde&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/BlockExplorer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dc262cde"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dc262cde', __exports__)) {
    api.reload('dc262cde', __exports__)
  }
  
  module.hot.accept("./BlockExplorer.vue?vue&type=template&id=dc262cde", () => {
    api.rerender('dc262cde', render)
  })

}


export default __exports__